module.exports = __webpack_public_path__ + "static/media/industria-banner.d834ff8e.jpg";